<script>
	import InfoPage from './InfoPage.svelte';
	import InfoSection from './InfoSection.svelte';
	import { Icon } from '../feathericons.js';

</script>

<InfoPage Title="Whittlesford">

<svelte:fragment slot="blurb">
<InfoSection src="pics/whitt-1.jpg" alt="Whittlesford">
<p>Whittlesford is a small village sandwiched between Duxford and Sawston with a direct road to the much desired Shelfords. It is home to one of my favourite places eat out, The Tickell Arms. It has a nice park and from the looks of it a set of walks on the north east side of the village. It’s website also features a delightful about page come legal disclaimer.</p>
<p><a href="https://www.whittleweb.org.uk/" target="new">{@html Icon("external-link","small")} Whittlesford website</a></p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="playgrounds">
<InfoSection id="whitlesford_playground" Title="Whittlesford Playground" src="pics/whitt-park.jpg" alt="Whittlesford Playground">
<p>
I haven’t let the monster loose on this one yet, but on taking the playgrounds picture I realised that it is better equipped than it first appears from the road side. It also has a public tennis court next to it, and a cricket green should you happen to have 22 friends with you.
</p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="foodanddrink">
<InfoSection id="tickell_arms" Title="The Tickell Arms" src="pics/whitt-tickle.jpg" alt="The Tickell Arms">
<p>
One of my favourite places to eat due to its beauty and the wonderful food. It is a little more highfalutin than my normal haunts so I tend to keep it in reserve for special occasions.
</p>
<p><a href="https://thetickellarms.co.uk/" target="new">{@html Icon("external-link","small")} The Tickell Arms website</a></p>

</InfoSection>
</svelte:fragment>

</InfoPage>
